export default __webpack_public_path__ + "static/media/pisodeportivo-large.e5edde55.jpg";